import { NavLink } from "react-router";
import type { NavSection } from "./nav.js";

/** The prototype's grouped left navigation; a horizontal scroller under 760 px by the shell CSS. */
export function SideNav(props: { sections: NavSection[] }) {
  return (
    <nav className="side" aria-label="Main">
      {props.sections.map((section) => (
        <div key={section.key} style={{ display: "contents" }}>
          <div className="grp">{section.label}</div>
          {section.items.map((item) => (
            <NavLink key={item.route} to={item.route}>
              <span>{item.label}</span>
              {item.badge && item.badgeValue !== null ? (
                <span
                  className={item.hot ? "n hot" : "n"}
                  aria-label={`${item.badgeValue} ${item.badge.replace(/_/g, " ")}`}
                >
                  {item.badgeValue}
                </span>
              ) : null}
              {item.tag ? <span className="tag">{item.tag}</span> : null}
            </NavLink>
          ))}
        </div>
      ))}
    </nav>
  );
}
